"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDirectFstT = void 0;
var types_1 = require("../types.js");
function getDirectFstT(t) {
    // !!! IMPORTANT !!!
    // **this unwrapping is assumed to happen here** by `typeExtends`
    // if this ever changes please reflect the change to `typeExtends` too
    // !!! IMPORTANT !!!
    while (t[0] !== types_1.PrimType.Pair)
        t = t[1];
    return t[1];
}
exports.getDirectFstT = getDirectFstT;
